<template>
    <div :class="['price-bar radius-3 flex justify-between	items-center ', customClass]">
        <div class="left-text">{{ leftText }}</div>
        <div class="right-text flex gap-3 items-center">
            <span class="amount font-bold">{{ amount }}</span>
            <span class="right-text">{{  rightText }}</span>
        </div>
    </div>
</template>

<script>

export default {
  name: 'PriceBar',
  props: {
    amount: {
        type: [Number, String],
        default: 0
    },
    leftText: {
        type: String,
        default: "最安値"
    },
    rightText: {
        type: String,
        default: "円/人"
    },
    customClass: {
        type: String,
        default: ""
    },
  }
 
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>